import qs from 'qs';

import { FULL_DEAL_QUERY_PARAMS } from '../config';

// @todo: в hasOffer название amount уже занято, поэтому задали такое название
const CUSTOM_AMOUNT_QUERY_NAME = 'requested_amount';

interface Args {
  offerId?: string;
  link: string;
  amount: number;
  term: number;
  showAuth?: boolean;
  referrer?: string;
}

export const buildHasOfferLinkForFullDeal = ({ link, offerId, amount, term, showAuth, referrer }: Args) =>
  `${link}&${qs.stringify({
    ...(offerId && { open_offer_id: offerId }),
    [CUSTOM_AMOUNT_QUERY_NAME]: amount,
    [FULL_DEAL_QUERY_PARAMS.term]: term,
    // @todo: нам нужно либо поменять в ПС логику showAuth и смотреть только на значение true, либо передавать
    // здесь пустое значение для showAuth (hasOffers не может принимать опциональные кверики)
    [FULL_DEAL_QUERY_PARAMS.showAuth]: showAuth || '',
    [FULL_DEAL_QUERY_PARAMS.referrer]: referrer || '',
  })}`;
